export const NAMESPACE = 'mylounge';

export const EA_CAROUSEL_CAMPAIGNS_COUNT = 4;

export const EA_UPCOMING_CAROUSEL_CAMPAIGNS_COUNT = 4;
